import React, { useEffect, useState, useCallback } from 'react'
import { Image } from 'antd'
import { ImageUrl } from '../../ApiServices/ApiServices'
import { get } from '../../ApiServices/ApiServices'
import { useNavigate } from 'react-router-dom';

function TopFiveRental() {
    const [TopCoat, setTopCoat] = useState([])
    const navigate = useNavigate();


    const TopCoatRental = async () => {
        try {
            const api = `top-five-inventories`;
            const response = await get(api);
            if (response?.status == true) {
                setTopCoat(response?.data)
            }
        } catch (err) {
            console.error('Error:', err);
            if (err?.message == "Invalid or expired token" || err?.message == "Invalid Token") {
                localStorage.removeItem('token');
                navigate('/login');
            }
        } finally {
        }
    };
    useEffect(() => {
        TopCoatRental()
    }, [])

    return (
        <>
            <div className="col-lg-5 d-flex align-items-stretch">
                <div className="chartBoxDashNew w-100">
                    <div className="card-title-group mb-2">
                        <div className="card-title">
                            <h6 className="title">Top 5 Rental Coats</h6>
                        </div>
                    </div>
                    <ul className="nk-top-products">
                        {TopCoat.map((data, index) => (
                            <li key={index} className="item">
                                <div className="thumb">
                                    <Image src={data?.image ? `${ImageUrl}${data?.image} ` : "assets/images/no-photo.png"} alt="" height={50} width={0} />
                                </div>
                                <div className="info">
                                    <div className="title"> <strong>{data?.style}</strong>-{data?.description}({data?.total_orders})</div>
                                    {/* <div className="price">{data?.coat_only_retail ? data?.coat_only_retail : "N/A"}</div> */}
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </>
    )
}

export default TopFiveRental
